import React, { useEffect, useState } from "react";
import one from "../../assets/Order/one.svg";
import two from "../../assets/Order/two.svg";
import three from "../../assets/Order/three.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import arrowright from "../../assets/arrowright.svg";
import SelectBox from "../CustomWidgets/SelectBox";
import { ConfigProvider, DatePicker, Space } from "antd";
import { useSelector } from "react-redux";
import moment from "moment";
import {
  getHomeDashData,
  getLahloobHomeDashData,
  getStorePaymentData,
} from "../../API  Functions/DashboardFunctions";
import LoadingSpinner from "../Loading";
import dayjs from "dayjs";
import DateFilter from "../ui/DateFilter";
import i18next from "i18next";
const { RangePicker } = DatePicker;

const HomeDash = ({ data }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const company_name = useSelector(
    (state) => state?.login?.user?.result?.company_name
  );

  const company_name_ar = useSelector(
    (state) => state?.login?.user?.result?.company_name_ar
  );

  const is_lahloob = useSelector(
    (state) => state.login?.user?.result?.is_lahloob
  );
  const [selectedRange, setSelectedRange] = useState("today");
  const [loading, setLoading] = useState(false);
  const [homeDashData, setHomeDashData] = useState();
  const [paymentDashData, setPaymentData] = useState();
  const [lahloobData, setLahloobData] = useState();
  const today = dayjs();
  const formatToday = today.format("YYYY-MM-DD");

  useEffect(() => {
    if (company_id) {
      if (is_lahloob) {
        getLahloobData();
      } else {
        getData();
      }
    }
  }, [user_id, is_lahloob]);

  const getData = async () => {
    setLoading(true);
    try {
      const res1 = await getHomeDashData(company_id, formatToday, formatToday);
      const Data = res1?.result?.[0];
      setHomeDashData(Data);

      const res2 = await getStorePaymentData(company_id);
      const Data2 = res2?.result;
      setPaymentData(Data2);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    }
  };

  const getLahloobData = async () => {
    setLoading(true);
    try {
      const res = await getLahloobHomeDashData(
        company_id,
        formatToday,
        formatToday
      );
      setLahloobData(res?.result?.data); // Set lahloob data
      setLoading(false);
    } catch (error) {
      console.error("Error fetching lahloob data:", error);
      setLoading(false);
    }
  };


  const fetchData = async (startDate, endDate) => {
    setLoading(true);
    try {
      let dashboardDataRes, paymentData;

      if (is_lahloob) {
        // Fetch lahloob data
        const res = await getLahloobHomeDashData(
          company_id,
          startDate,
          endDate
        );
        dashboardDataRes = res; // Assuming the response structure is correct
        setLahloobData(dashboardDataRes?.result?.data); // Set lahloob data
        setLoading(false);
      } else {
        // Fetch regular data
        dashboardDataRes = await getHomeDashData(
          company_id,
          startDate,
          endDate
        );

        paymentData = await getStorePaymentData(company_id);

        const data = dashboardDataRes?.result?.[0];
        setHomeDashData(data);
        setPaymentData(paymentData?.result);
        setLoading(false);
      }
    } catch (err) {
      console.error("Error fetching KPIs:", err);
      setLoading(false);
    }
  };

  const disabledDate = (current) => {
    // Disable dates that are after today
    return current && current > moment().endOf("day");
  };

  //   console.log("homeDashData", homeDashData);

  const values = is_lahloob
    ? {
      1: {
        img: one,
        heading: t("Total Revenue"),
        productsleft: `${t("EGP")} ${lahloobData?.total_revenue?.toFixed(2) || "0"
          }`,
        bgcolor: "#F0FBFF",
        textcolor: "#1F2937",
      },
      2: {
        img: two,
        heading: t("Total Online Payment"),
        productsleft: `${t("EGP")} ${lahloobData?.total_online_payment?.toFixed(2) || "0"
          }`,
        bgcolor: "#E8FDF2",
        textcolor: "#1F2937",
      },
      3: {
        img: three,
        heading: t("Total Cash Collected"),
        productsleft: `${t("EGP")} ${lahloobData?.total_cash_collected?.toFixed(2) || "0"
          }`,
        bgcolor: "#FFF4EB",
        textcolor: "#1F2937",
      },
      4: {
        img: three,
        heading: t("Cash to be Collected"),
        productsleft: `${t("EGP")} ${lahloobData?.total_balance?.toFixed(2) || "0.00"
          }`,
        bgcolor: "#ECFCFF",
        textcolor: "#0F172A",
        showArrow: true,
        //   wide: true,
      },
    }
    : {
      1: {
        img: one,
        heading: t("Online Sales"),
        productsleft: `${t("EGP")} ${homeDashData?.total_amount_online?.toFixed(2) || "0"
          }`,
        bgcolor: "#F0FBFF",
        textcolor: "#1F2937",
        action: () => navigate("/orders"),
      },
      2: {
        img: two,
        heading: t("POS Sales"),
        productsleft: `${t("EGP")} ${homeDashData?.total_amount_pos?.toFixed(2) || "0"
          }`,
        bgcolor: "#E8FDF2",
        textcolor: "#1F2937",
        // action: () => navigate("/pos/salesummary"),
        action: () => navigate("/pos/orders"),
      },
      3: {
        img: three,
        heading: t("Orders (Online)"),
        productsleft: `${homeDashData?.total_online_orders_count || "0"}`,
        bgcolor: "#FFF4EB",
        textcolor: "#1F2937",
      },
      4: {
        img: three,
        heading: t("Orders (POS)"),
        productsleft: `${Math.round(homeDashData?.total_pos_orders_count) || "0"
          }`,
        bgcolor: "#FFEBEE",
        textcolor: "#1F2937",
      },
      5: {
        img: three,
        heading: t("POS Profit"),
        productsleft: `${t("EGP")} ${homeDashData?.pos_profit?.toFixed(2) || "0.00"
          }`,
        bgcolor: "#F5F0FB",
        textcolor: "#1F2937",
      },
      6: {
        img: three,
        heading: t("POS Profit Percentage"),
        productsleft: `${homeDashData?.pos_profit_percentage?.toFixed(2) || "0.00"
          }%`,
        bgcolor: "#FFFDE7",
        textcolor: "#1F2937",
        wide: true, // custom flag to increase width
      },
      7: {
        img: three,
        heading: t("Cash to be Collected"),
        productsleft: `${t("EGP")} ${paymentDashData?.total_collection?.toFixed(2) || "0.00"
          }`,
        bgcolor: "#ECFCFF",
        textcolor: "#0F172A",
        //   action: () => navigate("/cash-collection"), // customize route
        //   showArrow: true,
        wide: true,
      },
    };

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="bg-white mt-5 rounded-xl shadow-sm p-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
          <h3 className="text-2xl font-semibold text-gray-800">
            {i18next.language === "ar" ? company_name_ar : company_name}
            {/* {company_name} */}
          </h3>

          {/* <div className="flex gap-x-1">
            <SelectBox
              value={selectedRange}
              options={[
                { value: "today", label: t("Today") },
                { value: "thisWeek", label: t("This Week") },
                { value: "thisMonth", label: t("This Month") },
                { value: "custom", label: t("Custom Range") },
              ]}
              onChange={handleDateRangeChange}
              placeholder={t("select_date_range")}
            />
            {selectedRange === "custom" && (
              <ConfigProvider direction={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                <RangePicker
                  className="w-full h-10 mt-2 range-picker-placeholder"
                  style={{ minWidth: 220 }}
                  onChange={handleRangePickerChange}
                  placeholder={[t("Start Date"), t("End Date")]}
                  disabledDate={disabledDate}
                />
              </ConfigProvider>
            )}
          </div> */}

          <DateFilter
            setSelectedRange={setSelectedRange}
            selectedRange={selectedRange}
            SubmitFilter={fetchData}
          />
        </div>

        <div
          className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 ${is_lahloob ? "xl:grid-cols-4" : "xl:grid-cols-5"
            }`}
        >
          {Object.values(values).map((val, index) => (
            <div
              key={index}
              className={`rounded-2xl p-4 shadow-sm transition-transform transform hover:scale-[1.02] hover:shadow-lg cursor-pointer ${val.wide ? "col-span-2" : ""
                }`}
              style={{ backgroundColor: val.bgcolor }}
              onClick={val.action}
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3">
                  <img src={val.img} alt="icon" className="w-10 h-10" />
                  <div className="flex flex-col">
                    <p className="text-base font-medium text-gray-700 truncate">
                      {val.heading}
                    </p>
                    <p
                      className="text-xl font-bold"
                      style={{ color: val.textcolor }}
                    >
                      {val.productsleft}
                    </p>
                  </div>
                </div>
                {val.showArrow && (
                  <img
                    src={arrowright}
                    className={`ms-2 ${i18n.language === "en" ? "" : "rotate-180"
                      }`}
                    alt="arrowright"
                    width={20}
                    height={20}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default HomeDash;
